import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer-bg">
      <h1 className="footer-caption ">
        <a href="http://8.134.141.78/" className="no-underline">
          Click to Try BioRocket Now!
        </a>
      </h1>
      <br />
      <h1 className="footer-caption">
        More information on{" "}
        <a href="https://gitlab.igem.org/2023/software-tools/sysu-software">
          Gitlab
        </a>
      </h1>
      <br />
      <h1 className="footer-caption">Contacts</h1>
      <p className="footer-text" style={{ paddingBottom: "20px" }}>
        If you have any question, please contact us sysu_software2023@163.com.
      </p>
      <br />{" "}
      <div className="footer-left">
        <h1 className="footer-caption">Address</h1>
        <p className="footer-text" style={{ paddingBottom: "20px" }}>
          No.135 West Xingang Road Guangzhou
        </p>
      </div>
      <div className="footer-right">
        <h1 className="footer-caption" style={{ paddingBottom: "10px" }}>
          Sponsor Recognition:{" "}
        </h1>
        <div className="sponsor-logo">
          <a href="https://tsingke.com.cn/">
            <img
              src="https://static.igem.wiki/teams/4826/wiki/logo-tsingke.svg"
              alt="TSINGKE"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
